import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [{
            path: '/h5/course/live',
            name: '/h5/course/live',
            component: () =>
                import ('./views/h5/course/live'),
        }, {
            path: '/h5/serve/volunteers',
            name: '/h5/serve/volunteers',
            component: () =>
                import ('./views/h5/serve/volunteers'),
            meta: {
                name: 'volunteers'
            }
        },
        {
            path: '/h5/serve/agency',
            name: '/h5/serve/agency',
            component: () =>
                import ('./views/h5/serve/agency'),
            meta: {
                name: 'agency'
            }
        },
        {
            path: '/h5/serve/agencyDetail',
            name: '/h5/serve/agencyDetail',
            component: () =>
                import ('./views/h5/serve/agencyDetail'),
        },
        //青少年美育培训基地列表
        {
          path: '/h5/serve/baseList',
          name: '/h5/serve/baseList',
          component: () =>
              import ('./views/h5/serve/baseList'),
          meta: {
              name: 'baseList'
          }
      },
      //青少年美育培训基地详情
      {
          path: '/h5/serve/baseDetail',
          name: '/h5/serve/baseDetail',
          component: () =>
              import ('./views/h5/serve/baseDetail'),
      },
        {
            path: '/h5/serve/courseList',
            name: '/h5/serve/courseList',
            component: () =>
                import ('./views/h5/serve/courseList'),
            meta: {
                name: 'courseList'
            }
        },
        {
            path: '/h5/serve/liveList',
            name: '/h5/serve/liveList',
            component: () =>
                import ('./views/h5/serve/liveList'),
            meta: {
                name: 'liveList'
            }
        },
        {
            path: '/h5/serve/activeList',
            name: '/h5/serve/activeList',
            component: () =>
                import ('./views/h5/serve/activeList'),
            meta: {
                name: 'activeList'
            }
        },
        {
            path: '/h5/serve/evaluationList',
            name: '/h5/serve/evaluationList',
            component: () =>
                import ('./views/h5/serve/evaluationList'),
        },
        {
            path: '/h5/serve/teacherList',
            name: '/h5/serve/teacherList',
            component: () =>
                import ('./views/h5/serve/teacherList'),
            meta: {
                name: 'teacherList'
            }
        },
        {
            path: '/h5/downLoad',
            name: '/h5/downLoad',
            component: () =>
                import ('./views/h5/downLoad'),
        },
        // 首页活动详情
        {
            path: '/h5/index/activityDetial',
            name: '/h5/mine/activityDetial',
            component: () =>
                import ('./views/h5/index/activityDetial'),
            meta: {
                name: 'activityDetial'
            }
        },
        // 市民夜校课程详情
        {
          path: '/h5/course/nightSchollDetails',
          name: '/h5/course/nightSchollDetails',
          component: () =>
              import ('./views/h5/course/nightSchollDetails'),
          meta: {
              name: 'nightSchollDetails'
          }
        },
        // 公益课程详情
        {
            path: '/h5/course/publicCourseDetails',
            name: '/h5/course/publicCourseDetails',
            component: () =>
                import ('./views/h5/course/publicCourseDetails'),
            meta: {
                name: 'publicCourseDetails'
            }
        },
        // 付费课程详情
        {
            path: '/h5/course/payCourseDetails',
            name: '/h5/course/payCourseDetails',
            component: () =>
                import ('./views/h5/course/payCourseDetails'),
            meta: {
                name: 'payCourseDetails'
            }
        },
        // 线下课程详情
        {
            path: '/h5/course/belowCourseDetails',
            name: '/h5/course/belowCourseDetails',
            component: () =>
                import ('./views/h5/course/belowCourseDetails'),
            meta: {
                name: 'belowCourseDetails'
            }
        },
        // 试看
        {
            path: '/h5/course/trySeeCourser',
            name: '/h5/course/trySeeCourser',
            component: () =>
                import ('./views/h5/course/trySeeCourser'),
            meta: {
                name: 'trySeeCourser'
            }
        },

        // 申请入驻
        {
            path: '/app/application/application',
            name: '/appapplication/application',
            component: () =>
                import ('./views/app/application/application'),
            meta: {
                name: 'application'
            }
        },
        {
            path: '/app/application/applicationHome',
            name: '/appapplication/applicationHome',
            component: () =>
                import ('./views/app/application/applicationHome'),
            meta: {
                name: 'applicationHome'
            }
        },
        {
            path: '/app/application/publicCulture',
            name: '/app/application/publicCulture',
            component: () =>
                import ('./views/app/application/publicCulture'),
            meta: {
                name: 'publicCulture'
            }
        },
        {
            path: '/app/application/applicationStates',
            name: '/appapplication/applicationStates',
            component: () =>
                import ('./views/app/application/applicationStates'),
            meta: {
                name: 'applicationStates'
            }
        },
        {
            path: '/h5/login',
            name: '/h5/login',
            component: () =>
                import ('./views/h5/login'),
        },
        {
            path: '/common/mine/serve',
            name: '/common/mine/serve',
            component: () =>
                import ('./views/common/mine/serve'),
        },
        {
            path: '/common/protocol/service',
            name: '/common/protocol/service',
            component: () =>
                import ('./views//common/protocol/service.vue')
        },
        {
            path: '/common/protocol/privacy',
            name: '/common/protocol/privacy',
            component: () =>
                import ('./views/common/protocol/privacy.vue')
        },
        {
            path: '/common/protocol/children',
            name: '/common/protocol/children',
            component: () =>
                import ('./views/common/protocol/children.vue')
        },
        {
            path: '/common/protocol/android_sdk',
            name: '/common/protocol/android_sdk',
            component: () =>
                import ('./views/common/protocol/android_sdk.vue')
        },
        {
            path: '/common/protocol/businessLicense',
            name: '/common/protocol/businessLicense',
            component: () =>
                import ('./views/common/protocol/businessLicense.vue')
        },
        {
            path: '/common/protocol/vip',
            name: '/common/protocol/vip',
            component: () =>
                import ('./views/common/protocol/vip.vue')
        },
        {
            path: '/common/protocol/buy',
            name: '/common/protocol/buy',
            component: () =>
                import ('./views/common/protocol/buy.vue')
        },
        {
            path: '/common/protocol/sdk',
            name: '/common/protocol/sdk',
            component: () =>
                import ('./views/common/protocol/sdk.vue')
        },
        {
            path: '/common/protocol/authentication',
            name: '/common/protocol/authentication',
            component: () =>
                import ('./views/common/protocol/authentication.vue')
        },
        {
            path: '/common/protocol/authority',
            name: '/common/protocol/authority',
            component: () =>
                import ('./views/common/protocol/authority.vue')
        },

        // 教师助手
        {
            path: '/teacher/common/question/question',
            name: '/teacher/common/question/question',
            component: () =>
                import ('./views/teacher/common/question/question.vue'),
            meta: {
                name: 'question'
            }
        },
        {
            path: '/teacher/common/question/questionDetail',
            name: '/teacher/common/question/questionDetail',
            component: () =>
                import ('./views/teacher/common/question/questionDetail.vue'),
            meta: {
                name: 'questionDetail'
            }
        },
        {
            path: '/teacher/common/servePromise',
            name: '/teacher/common/servePromise',
            component: () =>
                import ('./views/teacher/common/servePromise.vue'),
            meta: {
                name: 'servePromise'
            }
        },
        {
            path: '/teacher/common/privacy',
            name: '/teacher/common/privacy',
            component: () =>
                import ('./views/teacher/common/privacy.vue'),
            meta: {
                name: 'privacy'
            }
        },
        {
            path: '/teacher/common/sdk',
            name: '/teacher/common/sdk',
            component: () =>
                import ('./views/teacher/common/sdk.vue'),
            meta: {
                name: 'sdk'
            }
        },
        {
            path: '/teacher/common/android_sdk',
            name: '/teacher/common/android_sdk',
            component: () =>
                import ('./views/teacher/common/android_sdk.vue'),
            meta: {
                name: 'android_sdk'
            }
        },
        {
            path: '/teacher/common/authority',
            name: '/teacher/common/authority',
            component: () =>
                import ('./views/teacher/common/authority.vue'),
            meta: {
                name: 'authority'
            }
        },
        {
            path: '/teacher/common/userAgreement',
            name: '/teacher/common/userAgreement',
            component: () =>
                import ('./views/teacher/common/userAgreement.vue'),
            meta: {
                name: 'userAgreement'
            }
        },
        {
            path: '/teacher/common/children',
            name: '/teacher/common/children',
            component: () =>
                import ('./views/teacher/common/children.vue'),
            meta: {
                name: 'children'
            }
        }
    ]
})